
document.body.innerHTML+=`<div class='home-bullet-wrapper'></div>`;

const homeSections=document.querySelectorAll('.home-section');

homeSections.forEach((section,index) => {

    document.querySelector('.home-bullet-wrapper').innerHTML+=`<div class='home-bullet ${index==0?"active":""}'></div>`
});


const bullets=document.querySelectorAll('.home-bullet')

document.querySelector('.viewport').addEventListener('scroll',()=>{
    checkBullet()
})


const checkBullet=()=>{
    bullets.forEach((bullet,index) => {
        var section=homeSections[index]
        if(section.getBoundingClientRect().top<window.innerHeight/2&&section.getBoundingClientRect().top+section.clientHeight>window.innerHeight/2){
            bullet.classList.add('active')
        }else{
            bullet.classList.remove('active')
        }
    })
}

    checkBullet()